//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { CustomerFormTypes } from "models/formTypes";
//#endregion

/**
 * The single form-values -> API mapping for a reference person. Both the save (ReferencePost) and the
 * optimistic local update of a customer's referencePersonsList (Reference) go through here, so adding a
 * field to ReferencePost is one edit rather than three.
 */
export const toReferencePersonPost = (
  customerId: number,
  values: CustomerFormTypes.ReferencePerson
): WintSuperkollAPIModel.ReferencePost => ({
  customerId: customerId,
  name: values.name,
  emailAddress: values.email,
  phone: values.phoneNumber,
  isDefault: !!values.isDefault,
  // A cleared field is "" — omit it so the server stores null (PUT assigns every field) rather than "".
  referenceIdentifier: values.referenceId || undefined,
});

/** Same mapping plus the id, i.e. the shape a customer's own referencePersonsList holds. */
export const toReferencePerson = (values: CustomerFormTypes.ReferencePerson): WintSuperkollAPIModel.Reference => ({
  ...toReferencePersonPost(values.customerId, values),
  id: values.id as number,
});
